import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import React from 'react';

// MUI palette severity colors are too dark, so we're using our own
export const getStylesForSeverity = (severity: string) => {
  switch (severity.toUpperCase()) {
    case 'INFO':
      return {
        backgroundColor: '#bbdefb',
        borderTop: '5px solid #1976d2',
      };
    case 'WARNING':
      return {
        backgroundColor: '#ffe0b2',
        borderTop: '5px solid #f57c00',
      };
    case 'CRITICAL':
      return {
        backgroundColor: '#ef9a9a',
        borderTop: '5px solid #d32f2f',
      };
    default:
      return {
        backgroundColor: '#f5f5f5',
        borderTop: '5px solid #bdbdbd',
      };
  }
};

export const getIconForSeverity = (severity: string) => {
  switch (severity.toUpperCase()) {
    case 'INFO':
      return <InfoIcon sx={{ color: '#1976d2' }} />;
    case 'WARNING':
      return <WarningIcon sx={{ color: '#f57c00' }} />;
    case 'CRITICAL':
      return <ErrorIcon sx={{ color: '#d32f2f' }} />;
    default:
      return null;
  }
};
